












































































































import {
  defineComponent,
  watch,
  computed,
  reactive
} from "@vue/composition-api";
import { getComingEvents } from "@/api";
import { ApiResponse } from "@/api/types";
import { useRequest } from "@/helpers/hooks/useRequest";
import ListTable, { Props } from "@/components/Molecules/ListTable/index.vue";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";
import OccHeading from "@/components/Atoms/OccHeading/index.vue";
import dayjs from "dayjs";
import { useRouter } from "@/router";
import { EntryStatus } from "@/components/Pages/Dashboard/Organisms/ComingEvents/types";

export default defineComponent({
  name: "ComingEvents",
  components: {
    Heading,
    ListTable,
    OccHeading
  },
  emit: ["changeComingEventsLoading"],
  setup(_, { emit }) {
    const [{ data: comingEvents, loading: comingEventsLoading }] = useRequest(
      () => getComingEvents(),
      {
        immediate: true
      }
    );

    const router = useRouter();

    const headers = reactive<Props["headers"]>([
      {
        name: "イベントタイトル",
        minSizeContainer: "244px"
      },
      {
        name: "スケジュール名",
        subHeaders: [{ name: "開催日 | 開催場所" }],
        minSizeContainer: "244px"
      },
      {
        name: "応募数",
        subHeaders: [{ name: "本日 / 総合" }],
        minSizeContainer: "146px"
      },
      {
        name: "キャンセル数",
        subHeaders: [{ name: "本日 / 総合" }],
        minSizeContainer: "146px"
      },
      {
        name: "未抽選者数",
        minSizeContainer: "120px"
      }
    ]);

    const tableRows = computed(() => comingEvents.value?.events);

    watch(comingEventsLoading, newValue => {
      emit("changeComingEventsLoading", newValue);
    });

    const getPathWithStatus = (
      eventId: number,
      query: any,
      statuses: string[] = []
    ) => {
      const baseQuery = statuses
        .map(status => `event_status[]=${encodeURIComponent(status)}`)
        .join("&");

      return `${
        router.resolve({
          name: "JobEventEntryUsers",
          params: { eventId: String(eventId) },
          query
        }).href
      }${baseQuery ? "&" + baseQuery : ""}`;
    };

    const handleClickTodayEntry = (event: ApiResponse.ComingEventItem) => {
      if (event) {
        const query = {
          entry_date_from: dayjs().format("YYYY/MM/DD"),
          schedule_id: event.schedule_id
        };

        const path = getPathWithStatus(event.id, query, [
          EntryStatus.Entried,
          EntryStatus.PreEntried,
          EntryStatus.Elected
        ]);
        router.push(path).catch(err => err);
      }
    };

    const handleClickTotalEntry = (event: ApiResponse.ComingEventItem) => {
      if (event) {
        const query = {
          schedule_id: event.schedule_id
        };

        const path = getPathWithStatus(event.id, query, []);
        router.push(path).catch(err => err);
      }
    };

    const handleClickTodayCancel = (event: ApiResponse.ComingEventItem) => {
      if (event) {
        const query = {
          entry_date_from: dayjs().format("YYYY/MM/DD"),
          schedule_id: event.schedule_id
        };

        const path = getPathWithStatus(event.id, query, [EntryStatus.Canceled]);
        router.push(path).catch(err => err);
      }
    };

    const handleClickTotalCancel = (event: ApiResponse.ComingEventItem) => {
      if (event) {
        const query = {
          schedule_id: event.schedule_id
        };

        const path = getPathWithStatus(event.id, query, [EntryStatus.Canceled]);
        router.push(path).catch(err => err);
      }
    };

    const handleClickUnlottery = (event: ApiResponse.ComingEventItem) => {
      if (event) {
        const query = {
          schedule_id: event.schedule_id,
          unlottery: "true"
        };

        const path = getPathWithStatus(event.id, query, []);
        router.push(path).catch(err => err);
      }
    };

    const handleClickEventsMore = () => {
      const eventMoreRoute = router.resolve({
        name: "JobEvents"
      });
      window.open(eventMoreRoute.href, "_blank", "noopener");
    };

    return {
      comingEvents,
      headers,
      tableRows,
      comingEventsLoading,
      handleClickTodayEntry,
      handleClickTotalEntry,
      handleClickTodayCancel,
      handleClickTotalCancel,
      handleClickUnlottery,
      handleClickEventsMore
    };
  }
});
